<template>
    <div class="main-notice-list">
        <v-row align="center">
            <v-col>
                <tit-primary>공지사항</tit-primary>
            </v-col>
            <v-col cols="auto">
                <router-link to="/notice" class="main-notice-list__more-btn">
                    <txt-primary class="txt--sm">MORE<span class="plus">+</span></txt-primary>
                </router-link>
            </v-col>
        </v-row>
        <ul class="main-notice-list__table">
            <li v-for="(notification, index) in notifications" :key="index">
                <router-link :to="`/notice/${notification._id}`">
                    <div class="subject text-truncate">
                        {{ notification.subject }}
                    </div>
                    <div class="date">
                        {{ $dayjs(notification.createdAt).format("YYYY-MM-DD") }}
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import api from "@/api";
import TitPrimary from "@/components/publish/parents/typography/tit-primary.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

export default {
    components: {
        TitPrimary,
        TxtPrimary,
    },
    props: {},
    data() {
        return {
            notifications: [],
        };
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            try {
                let { summary, notifications } = await api.v1.center.notifications.gets({
                    params: { isMain: true },
                });
                this.notifications = notifications;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.main-notice-list {
    @media (min-width: 768px) {
        margin-right: 36px;
    }
    &__more-btn {
        display: flex;
        align-items: center;
        position: relative;
        min-height: 30px;
        @media (min-width: 768px) {
            min-height: 40px;
        }
        .txt {
            display: block;
            height: fit-content;
            font-weight: 600;
            color: var(--v-primary-base);
            padding-left: 1px;
            .plus {
                margin-left: 8px;
                font-size: 1.2em;
                @media (min-width: 768px) {
                    margin-left: 12px;
                }
            }
        }
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 2px;
            transition: width 0.2s ease-in-out;
            background-color: var(--v-primary-base);
        }
        &:hover {
            &::after {
                width: 100%;
            }
        }
    }
    &__table {
        margin-top: 20px;
        > li {
            > a {
                display: flex;
                gap: 4px;
                justify-content: space-between;
                padding: 16px 0;
                font-size: 14px;
                background-color: #fff;
                transition: background-color 0.2s ease-in-out;
                @media (min-width: 768px) {
                    padding: 20px 0;
                    font-size: 18px;
                }
                > .subject {
                    font-weight: 600;
                }
                > .date {
                    white-space: nowrap;
                    color: var(--v-grey-base);
                }
                &:hover {
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            &:not(:first-child) {
                border-top: 1px solid var(--v-grey-lighten4);
            }
        }
    }
}
</style>
